import { swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { IBienBanGiaiTheResponseBase } from '@/core/interfaces/ApiResponses';
import { BienBanGiaiTheService } from '@/core/services/BienBanGiaiThe.service';
import { ref, Ref } from 'vue';

export const useBienBanConfirmApprove = (onSuccess?: () => void | Promise<void>) => {
  const showConfirmDialog = ref(false);
  const showApproveDialog = ref(false);
  const currentBienBan: Ref<IBienBanGiaiTheResponseBase | null> = ref(null);
  const pending = ref(false);

  const openConfirmDialog = (bienBan: IBienBanGiaiTheResponseBase) => {
    currentBienBan.value = bienBan;
    showConfirmDialog.value = true;
  };

  const openApproveDialog = (bienBan: IBienBanGiaiTheResponseBase) => {
    currentBienBan.value = bienBan;
    showApproveDialog.value = true;
  };

  const closeConfirmDialog = () => {
    showConfirmDialog.value = false;
    currentBienBan.value = null;
  };

  const closeApproveDialog = () => {
    showApproveDialog.value = false;
    currentBienBan.value = null;
  };

  const handleConfirm = async () => {
    if (!currentBienBan.value || pending.value) {
      return;
    }

    pending.value = true;
    try {
      await BienBanGiaiTheService.confirm(currentBienBan.value.id);
      
      closeConfirmDialog();
      
      await swalNotification('Xác nhận thành công', 'success');
      
      if (onSuccess) {
        await onSuccess();
      }
    } catch (error) {
      closeConfirmDialog();
      await swalErrNotification(error, 'Xác nhận không thành công');
    } finally {
      pending.value = false;
    }
  };

  const handleApprove = async () => {
    if (!currentBienBan.value || pending.value) {
      return;
    }

    pending.value = true;
    try {
      await BienBanGiaiTheService.approve(currentBienBan.value.id);
      
      closeApproveDialog();
      
      await swalNotification('Duyệt thành công', 'success');
      
      if (onSuccess) {
        await onSuccess();
      }
    } catch (error) {
      closeApproveDialog();
      await swalErrNotification(error, 'Duyệt không thành công');
    } finally {
      pending.value = false;
    }
  };

  return {
    showConfirmDialog,
    showApproveDialog,
    currentBienBan,
    openConfirmDialog,
    openApproveDialog,
    closeConfirmDialog,
    closeApproveDialog,
    handleConfirm,
    handleApprove,
  };
};

